import { createReducer, successType } from 'shared/lib/lib/callAPI';
import * as types from 'actions/types';

const norm = (response) => (response && response.results ? response.results : (response || []));

const dataReducer = (state = { board: [], item: null, myRequests: [], changelog: [] }, action) => {
  switch (action.type) {
    case successType(types.ROADMAP_GET_BOARD):
      return { ...state, board: norm(action.response) };
    case successType(types.ROADMAP_GET_ITEM):
      return { ...state, item: action.response };
    case successType(types.ROADMAP_GET_MY_REQUESTS):
      return { ...state, myRequests: norm(action.response) };
    case successType(types.ROADMAP_GET_CHANGELOG):
      return { ...state, changelog: norm(action.response) };
    case types.LOGOUT:
      return { board: [], item: null, myRequests: [], changelog: [] };
    default:
      return state;
  }
};

export default createReducer(
  [types.ROADMAP_GET_BOARD, types.ROADMAP_GET_ITEM, types.ROADMAP_GET_MY_REQUESTS, types.ROADMAP_GET_CHANGELOG],
  dataReducer,
);
// State: state.roadmap = { loading, data: { board, item, myRequests, changelog }, error }
